import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FieldMappingEffects } from '../field-mapping/data/src/field-mapping/field-mapping.effects';
import {
  FieldMappingNamespace,
  FieldMappingReducer,
} from '../field-mapping/data/src/field-mapping/field-mapping.store';
import { FormConfigEffects } from '../field-mapping/data/src/form-config/form-config.effects';
import {
  FormConfigNamespace,
  FormConfigReducer,
} from '../field-mapping/data/src/form-config/form-config.store';
import { RemoteTemplateEffects } from '../field-mapping/data/src/remote-template/remote-template.effects';
import {
  RemoteTemplateNamespace,
  RemoteTemplateReducer,
} from '../field-mapping/data/src/remote-template/remote-template.store';
import { SourceEffects } from '../field-mapping/data/src/source/source.effects';
import { SourceNamespace, SourceReducer } from '../field-mapping/data/src/source/source.store';
import { AdpAdminEffects } from './adp/data/src/adp-admin/adp-admin.effects';
import {
  AdpAdminNamespace,
  AdpAdminReducer,
} from '../integrations/adp/data/src/adp-admin/adp-admin.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      RemoteTemplateEffects,
      SourceEffects,
      FormConfigEffects,
      FieldMappingEffects,
      AdpAdminEffects,
    ]),
    StoreModule.forFeature(RemoteTemplateNamespace, RemoteTemplateReducer),
    StoreModule.forFeature(SourceNamespace, SourceReducer),
    StoreModule.forFeature(FormConfigNamespace, FormConfigReducer),
    StoreModule.forFeature(FieldMappingNamespace, FieldMappingReducer),
    StoreModule.forFeature(AdpAdminNamespace, AdpAdminReducer),
  ],
})
export class RtiIntegrationsElementsDataModule {}
